module.exports = __webpack_public_path__ + "img/client-model-approved.9b41cafd.png";